module.exports = __webpack_public_path__ + "media/images/writer/emailer/twitter-icon-59561473e8fe3282cfcf5a9bcf38d062.png";